import script from "./Left.vue?vue&type=script&setup=true&lang=js"
export * from "./Left.vue?vue&type=script&setup=true&lang=js"

import "./Left.vue?vue&type=style&index=0&id=6016df1f&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6016df1f"]])

export default __exports__